import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

const PROMO_CODE = "FISCALRISK";

export default function PopupCTA() {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyCode = useCallback(() => {
    navigator.clipboard.writeText(PROMO_CODE).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, []);

  useEffect(() => {
    let shown = false;
    const maybeShow = () => {
      if (!shown && !sessionStorage.getItem("fr-popup")) {
        shown = true;
        setShow(true);
        window.removeEventListener("scroll", onScroll);
        clearTimeout(timer);
      }
    };
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.40) maybeShow();
    };
    window.addEventListener("scroll", onScroll);
    const timer = setTimeout(maybeShow, 30000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timer);
    };
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem("fr-popup", "1");
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={dismiss}>
      <div className="popup-card glass" onClick={e => e.stopPropagation()}>
        <button className="popup-close" onClick={dismiss} aria-label="Închide">×</button>

        <div className="popup-ring">
          <span className="popup-qmark">?</span>
        </div>

        <h3 className="popup-title">Cunoști profilul de risc fiscal al firmei tale?</h3>
        <p className="popup-sub">
          Descoperă în câteva minute unde se situează firma ta din punct de vedere fiscal.
          Contul este complet gratuit — plătești doar dacă vrei raportul PDF.
        </p>

        <ul className="popup-list">
          <li>Scor de risc fiscal 0–100</li>
          <li>Analiză automată a declarației SAF-T</li>
          <li>Detectare obligații fiscale neachitate</li>
        </ul>

        <div className="popup-promo">
          <div className="popup-promo-label">🎁 20% reducere la primul raport</div>
          <div className="popup-promo-row">
            <span className="popup-promo-code">{PROMO_CODE}</span>
            <button className="popup-promo-copy" onClick={copyCode}>
              {copied ? "✓ Copiat!" : "Copiază"}
            </button>
          </div>
          <div className="popup-promo-hint">Introdu codul la plată în contul tău</div>
        </div>

        <Link className="btn big full" to="/signup" onClick={dismiss}>
          Creează cont gratuit →
        </Link>
        <button className="popup-skip" onClick={dismiss}>Nu acum</button>
      </div>
    </div>
  );
}
